import { Skeleton } from 'components/app-components/ui/skeleton';
import MemoizedCopyableText from 'components/generic-components/copyableText';

interface CardCVVProps {
  cvv?: string;
  showDetails: boolean;
  isLoadingCardDetails: boolean;
}

/**
 * Card CVV field with copy functionality
 */
export const CardCVV = ({ cvv, showDetails, isLoadingCardDetails }: CardCVVProps) => {
  return (
    <div className="flex items-center gap-2">
      {isLoadingCardDetails ? (
        <Skeleton className="h-3 w-12 bg-neutral-500" />
      ) : (
        <p className="text-sm font-medium tabular-nums text-white">{showDetails ? cvv || '•••' : '•••'}</p>
      )}
      {showDetails && !isLoadingCardDetails && cvv && (
        <span className="text-white">
          <MemoizedCopyableText text={cvv} onlyIconMode={true} showBorder={false} iconStrokeColor="white" />
        </span>
      )}
    </div>
  );
};
